import { c } from 'react-compiler-runtime';
import React, { forwardRef } from 'react';
import { isElement } from 'react-is';
import classes from './UnderlineTabbedInterface.module.css.js';
import { clsx } from 'clsx';
import { jsx, jsxs } from 'react/jsx-runtime';
import CounterLabel from '../../CounterLabel/CounterLabel.js';

const GAP = 8;
const UnderlineWrapper = /*#__PURE__*/forwardRef((props, ref) => {
  const $ = c(13);
  let children;
  let className;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      children,
      className,
      as: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t0;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t0 = $[4];
  }
  const Component = t0 === undefined ? "div" : t0;
  let t1;
  if ($[5] !== className) {
    t1 = clsx(classes.UnderlineWrapper, className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = ref;
  let t3;
  if ($[7] !== Component || $[8] !== children || $[9] !== rest || $[10] !== t1 || $[11] !== t2) {
    t3 = /*#__PURE__*/jsx(Component, {
      className: t1,
      ref: t2,
      ...rest,
      children: children
    });
    $[7] = Component;
    $[8] = children;
    $[9] = rest;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
});
const UnderlineItemList = /*#__PURE__*/forwardRef((t0, forwardedRef) => {
  const $ = c(7);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== forwardedRef || $[5] !== rest) {
    t1 = /*#__PURE__*/jsx("ul", {
      className: classes.UnderlineItemList,
      ref: forwardedRef,
      ...rest,
      children: children
    });
    $[3] = children;
    $[4] = forwardedRef;
    $[5] = rest;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
});
const LoadingCounter = () => {
  const $ = c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/jsx("span", {
      className: classes.LoadingCounter
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const UnderlineItem = /*#__PURE__*/React.forwardRef((props, ref) => {
  const $ = c(27);
  let Icon;
  let children;
  let className;
  let counter;
  let iconsVisible;
  let loadingCounters;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      as: t0,
      children,
      counter,
      icon: Icon,
      iconsVisible,
      loadingCounters,
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = Icon;
    $[2] = children;
    $[3] = className;
    $[4] = counter;
    $[5] = iconsVisible;
    $[6] = loadingCounters;
    $[7] = rest;
    $[8] = t0;
  } else {
    Icon = $[1];
    children = $[2];
    className = $[3];
    counter = $[4];
    iconsVisible = $[5];
    loadingCounters = $[6];
    rest = $[7];
    t0 = $[8];
  }
  const Component = t0 === undefined ? "a" : t0;
  let t1;
  if ($[9] !== className) {
    t1 = clsx(classes.UnderlineItem, className);
    $[9] = className;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== Icon || $[12] !== iconsVisible) {
    t2 = iconsVisible && Icon && /*#__PURE__*/jsx("span", {
      "data-component": "icon",
      children: isElement(Icon) ? Icon : /*#__PURE__*/jsx(Icon, {})
    });
    $[11] = Icon;
    $[12] = iconsVisible;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== children) {
    t3 = children && /*#__PURE__*/jsx("span", {
      "data-component": "text",
      "data-content": children,
      children: children
    });
    $[14] = children;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== counter || $[17] !== loadingCounters) {
    t4 = counter !== undefined ? loadingCounters ? /*#__PURE__*/jsx("span", {
      "data-component": "counter",
      children: /*#__PURE__*/jsx(LoadingCounter, {})
    }) : /*#__PURE__*/jsx("span", {
      "data-component": "counter",
      children: /*#__PURE__*/jsx(CounterLabel, {
        children: counter
      })
    }) : null;
    $[16] = counter;
    $[17] = loadingCounters;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== Component || $[20] !== ref || $[21] !== rest || $[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4) {
    t5 = /*#__PURE__*/jsxs(Component, {
      ...rest,
      ref: ref,
      className: t1,
      children: [t2, t3, t4]
    });
    $[19] = Component;
    $[20] = ref;
    $[21] = rest;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
});

export { GAP, LoadingCounter, UnderlineItem, UnderlineItemList, UnderlineWrapper };
